export function applyHighlightFilters(metadataItem, highlights) {
    const filter = highlights === null || highlights === void 0 ? void 0 : highlights.find((f) => getMetadataItemId(metadataItem) === f.attribute.id);
    if (filter && !filter.config.disabled) {
        if (filter.isScope) {
            filter.isScope = false;
        }
        metadataItem.jaql.in = {
            selected: filter.jaql(),
        };
    }
    return metadataItem;
}
export function matchHighlightsWithAttributes(attributesMetadata, highlights) {
    const highlightsWithAttributes = [];
    const highlightsWithoutAttributes = [];
    highlights.forEach((filter) => {
        const isMatch = attributesMetadata.some((d) => getMetadataItemId(d) === filter.attribute.id);
        if (isMatch) {
            highlightsWithAttributes.push(filter);
        }
        else {
            highlightsWithoutAttributes.push(filter);
        }
    });
    return [highlightsWithAttributes, highlightsWithoutAttributes];
}
export function getMetadataItemId(metadataItem) {
    const { dim, level, dateTimeLevel, bucket } = metadataItem.jaql;
    let id = `${dim}`;
    if (level || dateTimeLevel) {
        id += `_${level || dateTimeLevel}`;
    }
    if (bucket) {
        id += `_${bucket}`;
    }
    return id;
}
//# sourceMappingURL=highlights.js.map